import { request } from './Api';
import { recordActivity, recordTransaction } from './ActivityService';

const listSubmission = async (resource) => {
    const response = await request(`/api/admin/${resource}`);
    const items = Array.isArray(response.items)
        ? response.items
        : Array.isArray(response.data) ? response.data : [];

    return {
        items,
        pagination: response.pagination || null
    };
};

const updateSubmission = async (resource, uuid, changes) => {
    const response = await request(`/api/admin/${resource}/${encodeURIComponent(uuid)}`, {
        method: 'PATCH',
        body: changes
    });
    recordActivity({
        type: resource,
        action: `Updated ${resource} submission`,
        entityType: resource,
        entityUuid: uuid,
        metadata: changes
    });
    return response.data;
};

export const listFantasyRequests = () => listSubmission('fantasy');
export const listCastingSignups = () => listSubmission('casting');
export const listContacts = () => listSubmission('contact');

export const updateFantasyRequest = (uuid, changes) => updateSubmission('fantasy', uuid, changes);
export const updateCastingSignup = (uuid, changes) => updateSubmission('casting', uuid, changes);
export const updateContact = (uuid, changes) => updateSubmission('contact', uuid, changes);

export const createFantasyInvoice = async (uuid, invoice) => {
    const response = await request(`/api/admin/fantasy/${encodeURIComponent(uuid)}/invoice`, {
        method: 'POST',
        body: invoice
    });
    const createdInvoice = response.data || {};
    const amount = Number(createdInvoice.amount ?? invoice.amount ?? createdInvoice.total ?? 0);
    recordTransaction({
        type: 'invoice',
        action: `Created invoice${invoice.invoiceNumber ? ` ${invoice.invoiceNumber}` : ''}`,
        description: `Invoice${invoice.invoiceNumber ? ` ${invoice.invoiceNumber}` : ''}`,
        amount,
        entityType: 'fantasy',
        entityUuid: uuid,
        metadata: { invoiceNumber: invoice.invoiceNumber }
    });
    return createdInvoice;
};